import React from "react";
import "./help.scss";

const HelpComponent = () => {
  return (
    <div className="reading-help">
      <h1>Hotkeys</h1>
      <dl>
        <dt>
          <kbd>CTRL</kbd> + <kbd>CLICK</kbd>
        </dt>
        <dd>allows defining reading order</dd>
        <dt>
          <kbd>SHIFT</kbd> + <kbd>CLICK</kbd>
        </dt>
        <dd>allows defining continuation paragraphs</dd>
      </dl>
    </div>
  );
};
export const Help = React.memo(HelpComponent);
